// extracted by mini-css-extract-plugin
export default {"comments":"PhotosComments_comments__XRpxr","single":"PhotosComments_single__xZgMK"};